import displaySideNavScreen from './display-screen';
import {toggleSubNav, triggerCloseDropdownMenu} from './section-nav-sub';
import openSectionMenu from './open-section-menu';
import closeSectionMenu from './close-section-menu';

export default function addNavEventHandlers() {
    //$('.site-header').append('<div style="padding: 10px 20px;border-radius:4px;margin: 20px 0;background: red; color: #fff; font-size: 14px;">I am experimenting with the hover setting in the top nav right now. It may break but this is temporary. - AQ</div>');

    // Control top nav hover/tap dropdowns
    $(document).on("touchstart mouseenter", ".rwnav-top-menu-wrapper", function(){
        $('body').addClass("rwnav-dropdown-open").attr('data-list', $(this).data("list"));
    });

    $(document).on("mouseenter", ".rwnav-top-account", function(){
        if ($('.rwnav-logout').length >= 1) { return; }

        const isSmallerScreen = window.matchMedia('(max-width: 1000px)').matches;
        if (isSmallerScreen) { return }

        const logoutLink = `
        <div class="rwnav-logout">
            <a href="/users/subinfo.php">Account</a>
            <a href="/users/logout.php">
            Logout 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                viewBox="0 0 24 24" stroke-width="1" stroke="#ffffff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"></path>
                <path d="M7 12h14l-3 -3m0 6l3 -3"></path>
            </svg>
            </a>
        </div>
        `;

        $(".rwnav-top-account").wrap('<div class="rwnav-account-wrapper"></div>');
        $('.rwnav-account-wrapper').append(logoutLink);
    });

    $(document).on("mouseleave", ".rwnav-account-wrapper", function(e){
        const isSmallerScreen = window.matchMedia('(max-width: 1000px)').matches;
        if (isSmallerScreen) { return }

        $('.rwnav-logout').remove();
        $('.rwnav-top-account').unwrap();
    });
     
    $(document).on("mouseleave", ".site-header", function(e){
        /* 
        const $movingTo = $(e.relatedTarget);

        if ($movingTo.hasClass('rwnav') || $movingTo.hasClass('rwnav-top-menus')) {
            return; 
        }
        */
        
        $('body').removeClass("rwnav-dropdown-open").attr('data-list', '');
    });

    $(document).on('click', '.rwnav-top-hamburger', function(){
        $('body').addClass('rwnav-is-open');
        $('.fs-close-button-sticky').trigger('click');
    });

    $(document).on('click', '.rwnav-top-hamburger-close', function(){
        $('body').removeClass('rwnav-is-open');
    });

    $(document).on('click', '.rwnav-top-search-icon', function(){
        $('body').addClass('rwnav-player-search-is-open');
        $('#search-for-players').focus();
    });

    $(document).on('click', '.rwnav-top-search-close', function(){
        $('body').removeClass('rwnav-player-search-is-open');
    });

    $(document).on('click', '.rwnav-item.has-link i, .rwnav-item:not(.has-link)', function(e){
        const $el = $(e.currentTarget);
        const isPlusButton = $el.get(0).tagName === 'I';
        console.log(isPlusButton);
        const $item = isPlusButton ? $el.parents('.rwnav-item') : $el;

        const screenToDisplay = $item.data('list') || '';
        if (!screenToDisplay) { return; }

        const screenName = $item.clone().find('span').remove().end().text().replace('+','');
        const currentScreen = $('.rwnav-screen.is-open').data('list');
        const currentScreenName = $('#rwnav-title-name').text();
        
        displaySideNavScreen({
            screenToDisplay, 
            screenName, 
            backButtonScreen: currentScreen, 
            backButtonScreenName: currentScreenName,
            back: false,
        });
    });

    $(document).on('click', '#rwnav-back', function(){
        const $backButton = $('#rwnav-back');
        const backScreens = $backButton.data('screens');
        const backScreenNames = $backButton.data('screen-names');

        const {screen, screenName} = backScreens.pop();

        const currentScreen = $('.rwnav-screen.is-open').data('list');
        const currentScreenName = $('#rwnav-title-name').text();

        displaySideNavScreen({
            screenToDisplay: screen, 
            screenName, 
            backButtonScreen: currentScreen, 
            backButtonScreenName: currentScreenName,
            back: true,
        });

        $backButton.data('screens', backScreens);
        $backButton.data('screen-names', backScreenNames);

    });

    // Toggles a sub navigation dropdown menu
    $(document).on('touchstart mouseenter', '.rwnav-section__item', toggleSubNav);

    // Hides a sub navigation dropdown menu
    $(document).on('mouseleave', '.rwnav-section__item, .rwnav-section-sub__group', triggerCloseDropdownMenu);

    // Open the section nav side menu
    $(document).on('click', '.open-section-nav', openSectionMenu);

    // Close the section nav side menu
    $(document).on('click', '.close-section-nav, .rwnav-section-side-is-open', closeSectionMenu);

    // Toggle a dropdown in the section nav side menu
    $(document).on('click', '.rwnav-section-side-menu__group.has-sub-items', function(e){
        if ($(e.target).hasClass('rwnav-section-side-menu__link')) { return; }

        const $group = $(e.currentTarget);
        const closingGroup = $group.hasClass('is-open');

        $('.rwnav-section-side-menu__group').removeClass('is-open');
        $('.rwnav-section-side-menu__items').addClass('hide');

        if (closingGroup) { return; }

        $group.addClass('is-open');
        $group.find('.rwnav-section-side-menu__items').removeClass('hide');
    });

}
